import "./AboutUs.css";
import CupImage from "../../images/CuoreChicchi.jpg"
import MisceleImage from "../../images/MisceleArtigianali.jpg"
import familyImage from "../../images/Famiglia.jpg"

export default function AboutUs() {

    return (
        <div id="aboutUsText">
            <h1>Chi Siamo?</h1>

            <div id="aboutUsParWrapper">
                <div id="text">
                    <p>La storia di <strong>Caffeina</strong> nasce dalla passione per il <strong>caffè</strong>, una
                        storia
                        basata e cresciuta
                        con 3 elementi chiave: famiglia, visione e sorrisi.</p>
                </div>
                <img id="aboutUsImage" src={CupImage} alt="CupImage"/>
            </div>


            <div id="aboutUsParWrapper">
                <img src={MisceleImage} alt="MisceleImage"/>
                <div id="text">
                    <p>Grazie al coraggio e alla tenacia dei due fondatori <strong>Donato e Rosa</strong>, e al loro
                        spiccato
                        spirito imprenditoriale,
                        nasce ad Altamura il primo negozio dove poter degustare un buon
                        caffè <strong>artigianale</strong>.
                    </p>

                    <p>Con la loro intraprendenza, Rosa e Donato trasformano la loro passione per il caffè in una vera e
                        propria
                        realtà leader, unica nel suo genere. Danno l’input alla <strong>cultura del caffè
                            artigianale</strong> e
                        coraggiosamente
                        abbandonano i grossi brand industriali, che sicuramente sono facili da vendere ma non in linea
                        con
                        il
                        fondamentale principio della <strong>qualità</strong> del prodotto.</p>
                    <p>Dopo anni di formazione e dedizione al loro lavoro, per offrire sempre il meglio del caffè,
                        selezionano
                        le
                        migliori miscele arabiche accompagnandole dalla tostatura, per tutto il processo di produzione,
                        fino
                        al
                        confezionamento, controllando l'intera filiera in ogni suo piccolo dettaglio.</p>
                </div>
            </div>

            <div id="aboutUsParWrapper">
                <div id="text">
                    <p><strong>Caffeina</strong> è un luogo, una casa, un’azienda fatta di persone, una famiglia che ha
                        per
                        passione il caffè
                        che vi invita a gustare le varie miscele ottenute con esperienza e tanto <strong>amore</strong>.
                    </p>

                    <p><strong>Caffeina Coffee Store:</strong> ogni tazzina di caffè è
                        un’esperienza <strong>indimenticabile!</strong></p>
                </div>
                <img src={familyImage} alt="familyImage"/>
            </div>
        </div>
    )
}